
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import subscriptions from "@/api/routes/subscriptions";

import ImageView from "@/components/ImageView.vue";
import AudioView from "@/components/audioView.vue";
import VideoView from "@/components/VideoView.vue";
import PdfView from "@/components/PdfView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import SubscriptionUnit from "@/models/subscriptions/unit";
import DocumentVersion from "@/models/unit/unitable/document/version";

@Component({
  name: "CSubscriptionUnitDocument",
  components: {
    ImageView,
    AudioView,
    VideoView,
    PdfView,
    CFileDownload
  }
})
export default class CSubscriptionUnitDocument extends Vue {
  @Prop({ required: true }) protected subscription_unit!: SubscriptionUnit;
  @Prop({ required: true }) private is_current_user_subscription!: boolean;

  public url: string = "";
  public url_file_type: string = "";
  public url_type: "image" | "video" | "audio" | "pdf" | null = null;

  protected async created() {
    await this.changeDocument();
  }

  @Watch("subscription_unit")
  private async changeDocument() {
    const document = this.subscription_unit.unit_version
      .unitable as DocumentVersion;

    this.url = document.url;
    this.url_file_type = document.file_type;

    if (document.isImage()) {
      this.url_type = "image";
    } else if (document.isVideo()) {
      this.url_type = "video";
    } else if (document.isAudio()) {
      this.url_type = "audio";
    } else if (document.isPdf()) {
      this.url_type = "pdf";
    } else {
      this.url_type = null;
    }

    await this.calculate();
  }

  private async calculate() {
    if (!this.is_current_user_subscription) {
      return;
    }

    return this.$api
      .get(subscriptions.calculate_unit(this.subscription_unit.id))
      .then(() => {
        this.$emit("end", true);
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
